import { useContext } from 'react';

import { XYChartLinearSelectionContext } from '../context/XYChartLinearSelection.context.js';

export const useXYChartLinearSelection = () => {
  const context = useContext(XYChartLinearSelectionContext);
  if (!context) {
    throw new Error(
      'useXYChartLinearSelection must be used within a XYChartLinearSelectionProvider',
    );
  }

  return context;
};
